// Basit, draft-js'siz Mazot MailScheduler – scheduledMails şemasıyla
import React, { useEffect, useMemo, useState } from "react";
import { db, auth } from "../firebaseConfig";
import {
  collection, addDoc, serverTimestamp, getDocs, deleteDoc, doc, updateDoc
} from "firebase/firestore";

const TAG_HINTS = {
  "@gecensenebuaytuketimkıyasla-haftalık": "Hafta bazında bu dönem vs önceki dönem kıyas tablosu",
  "@gecensenebuaytuketimkıyasla-aylık": "Ay bazında bu dönem vs önceki dönem kıyas tablosu",
  "@ilk3veson3personelsaha{TESIS}-{haftalık|aylık}": "Belirtilen saha için en iyi/en zayıf 3 şoför",
  "@ilk3veson3aracsaha{TESIS}-{haftalık|aylık}": "Belirtilen saha için en iyi/en zayıf 3 araç",
  "@tankdurumu-{haftalık|aylık}": "Tankların son seviye tablosu",
};

const freqMap = {
  "monthly-1": "aylik_1",
  "monthly-first-monday": "aylik_ilk_pzt",
  "weekly-first-monday": "haftalik_ilk_pzt",
  "daily": "daily",
  "special": "ozel_tarih",
};

const MazotMailScheduler = () => {
  const [emailOptions, setEmailOptions] = useState([]);
  const [toInput, setToInput] = useState("");
  const [subject, setSubject] = useState("");
  const [periodType, setPeriodType] = useState("monthly-1");
  const [specialDate, setSpecialDate] = useState("");
  const [sendHour, setSendHour] = useState("08:00");
  const [duration, setDuration] = useState("30");
  const [htmlBody, setHtmlBody] = useState("");
  const [saving, setSaving] = useState(false);

  const [scheduledList, setScheduledList] = useState([]);
  const [selectedMail, setSelectedMail] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "users"));
      const mails = snap.docs.map(d => d.data()?.email).filter(Boolean);
      setEmailOptions(mails.sort());
    })();
  }, []);

  const fetchMails = async () => {
    const snap = await getDocs(collection(db, "scheduledMails"));
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setScheduledList(list);
  };
  useEffect(() => { fetchMails(); }, []);

  const parsedTo = useMemo(
    () => toInput.split(",").map(s => s.trim()).filter(Boolean),
    [toInput]
  );

  const highlightedPreview = useMemo(() => {
    return (htmlBody || "").replace(/@[^\s<]+/gu, (m) =>
      `<strong title="${TAG_HINTS[m] || "Etiket"}">${m}</strong>`
    );
  }, [htmlBody]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!parsedTo.length) return alert("Alıcı (To) girin.");
    if (!subject.trim()) return alert("Konu girin.");
    if (!htmlBody.trim()) return alert("İçerik girin.");

    const [hour, minute] = sendHour.split(":").map(Number);
    const now = new Date();
    const frequency = freqMap[periodType];

    let nextRun;
    if (frequency === "ozel_tarih") {
      if (!specialDate) return alert("Özel tarih seçin.");
      const [y, m, d] = specialDate.split("-").map(Number);
      nextRun = new Date(y, m - 1, d, hour, minute);
    } else {
      nextRun = new Date(now);
      nextRun.setHours(hour, minute, 0, 0);
      if (nextRun <= now && frequency === "daily") nextRun.setDate(nextRun.getDate() + 1);
    }

    const payload = {
      to: parsedTo,
      frequency,
      ozelTarih: periodType === "special" ? specialDate : null,
      time: sendHour,
      duration: Number(duration),
      contentHtml: htmlBody,
      contentRaw: null,
      subject,
      createdAt: serverTimestamp(),
      createdBy: auth?.currentUser?.email || "anonymous",
      active: true,
      nextRun,
    };

    try {
      setSaving(true);
      await addDoc(collection(db, "scheduledMails"), payload);
      alert("✅ Mail görevi kaydedildi.");
      setSubject(""); setToInput(""); setHtmlBody("");
      setSpecialDate(""); setPeriodType("monthly-1");
      setSendHour("08:00"); setDuration("30");
      fetchMails();
    } catch (err) {
      console.error(err);
      alert("Kaydetme hatası: konsola bak.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu görevi silmek istiyor musunuz?")) return;
    await deleteDoc(doc(db, "scheduledMails", id));
    if (selectedMail?.id === id) setSelectedMail(null);
    fetchMails();
  };

  const handleToggleActive = async (id, current) => {
    await updateDoc(doc(db, "scheduledMails", id), { active: !current });
    fetchMails();
  };

  return (
    <div style={{ padding: 16 }}>
      <style>{`
        .card{ border:1px solid #e5e7eb; border-radius:10px; padding:14px; margin-bottom:16px; background:#fff; }
        .title{ font-weight:700; margin-bottom:10px; }
        .row{ display:flex; gap:10px; flex-wrap:wrap; }
        input, textarea, select{
          width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px; font-size:14px;
        }
        .btn{ padding:10px 14px; border-radius:8px; border:1px solid #d1d5db; background:#111827; color:#fff; font-weight:600; cursor:pointer; }
        .btn.light{ background:#fff; color:#111827; }
        .muted{ color:#6b7280; font-size:12px; }
        .grid2{ display:grid; grid-template-columns: 1fr 1fr; gap:10px; }
        .grid3{ display:grid; grid-template-columns: 1fr 1fr 1fr; gap:10px; }
        @media (max-width: 1000px){ .grid2, .grid3{ grid-template-columns: 1fr; } }
        table{ width:100%; border-collapse:collapse; font-size:13px; }
        th, td{ border:1px solid #e5e7eb; padding:8px; text-align:left; }
        thead th{ background:#f8fafc; }
        .preview{ border:1px dashed #cbd5e1; border-radius:10px; padding:12px; background:#f8fafc; }
      `}</style>

      <h2>Otomatik Mail Gönderici (Mazot)</h2>

      <div className="card" style={{ background:"#fffbeb", borderColor:"#fde68a" }}>
        <div className="title">Mazot Etiket Rehberi</div>
        <code className="block">@gecensenebuaytuketimkıyasla-haftalık</code><br/>
        <code className="block">@gecensenebuaytuketimkıyasla-aylık</code><br/>
        <code className="block">@ilk3veson3personelsahaGÜVERCİNLİK-haftalık</code><br/>
        <code className="block">@ilk3veson3aracsahaGÜVERCİNLİK-aylık</code><br/>
        <code className="block">@tankdurumu-haftalık</code>
      </div>

      <form className="card" onSubmit={handleSave}>
        <div className="title">Yeni Görev</div>

        <div className="grid2">
          <div>
            <div className="muted">Konu</div>
            <input value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Mail konusu" />
          </div>
          <div>
            <div className="muted">Alıcılar (virgüllü)</div>
            <input
              list="email-options"
              value={toInput}
              onChange={e=>setToInput(e.target.value)}
              placeholder="ali@site.com, veli@site.com"
            />
            <datalist id="email-options">
              {emailOptions.map(e => <option key={e} value={e} />)}
            </datalist>
          </div>
        </div>

        <div className="grid3" style={{ marginTop: 10 }}>
          <div>
            <div className="muted">Periyot</div>
            <select value={periodType} onChange={e=>setPeriodType(e.target.value)}>
              <option value="monthly-1">Her Ayın 1'i</option>
              <option value="monthly-first-monday">Her Ayın İlk Pazartesi</option>
              <option value="weekly-first-monday">Her Haftanın İlk Pazartesi</option>
              <option value="daily">Her Gün</option>
              <option value="special">Özel Tarih</option>
            </select>
          </div>
          <div>
            <div className="muted">Gönderim Saati</div>
            <input type="time" value={sendHour} onChange={e=>setSendHour(e.target.value)} />
          </div>
          <div>
            <div className="muted">Süre (dk)</div>
            <input type="number" min={5} value={duration} onChange={e=>setDuration(e.target.value)} />
          </div>
        </div>

        {periodType === "special" && (
          <div style={{ marginTop: 10 }}>
            <div className="muted">Özel Tarih</div>
            <input type="date" value={specialDate} onChange={e=>setSpecialDate(e.target.value)} />
          </div>
        )}

        <div style={{ marginTop: 10 }}>
          <div className="muted">HTML İçerik</div>
          <textarea
            rows={10}
            placeholder="<p>Merhaba ...</p>"
            value={htmlBody}
            onChange={e=>setHtmlBody(e.target.value)}
          />
        </div>

        <div className="preview" style={{ marginTop: 10 }}>
          <div className="muted">Önizleme</div>
          <div dangerouslySetInnerHTML={{ __html: highlightedPreview || "<em>(boş)</em>" }} />
        </div>

        <div className="row" style={{ marginTop: 12 }}>
          <button className="btn" type="submit" disabled={saving}>
            {saving ? "Kaydediliyor..." : "Kaydet"}
          </button>
        </div>
      </form>

      <div className="card">
        <div className="title">📋 Kayıtlı Görevler</div>

        <input
          className="muted"
          style={{ width:"100%", marginBottom:10, padding:8, border:'1px solid #e5e7eb', borderRadius:8 }}
          placeholder="Ara (konu)..."
          value={searchTerm}
          onChange={e=>setSearchTerm(e.target.value)}
        />

        <table>
          <thead>
            <tr>
              <th>#</th><th>Konu</th><th>Ekleyen</th><th>Eklenme</th>
              <th>Son Gönderim</th><th>Sonraki</th><th>Alıcılar</th><th>Aktif</th><th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {scheduledList
              .filter(m => (m.subject || "").toLowerCase().includes((searchTerm||"").toLowerCase()))
              .map((m, i) => (
              <tr key={m.id} onClick={()=>setSelectedMail(m)} style={{ cursor:"pointer", background: selectedMail?.id===m.id ? "#eef2ff" : undefined }}>
                <td>{i+1}</td>
                <td>{m.subject}</td>
                <td>{m.createdBy}</td>
                <td>{m.createdAt?.toDate?.().toLocaleString?.()}</td>
                <td>{m.lastSentAt?.toDate?.().toLocaleString?.() || "-"}</td>
                <td>{m.nextRun?.toDate?.().toLocaleString?.()}</td>
                <td>{Array.isArray(m.to) ? m.to.join(", ") : "-"}</td>
                <td>
                  <button className="btn light" onClick={(e)=>{ e.stopPropagation(); handleToggleActive(m.id, m.active); }}>
                    {m.active ? "Aktif" : "Pasif"}
                  </button>
                </td>
                <td>
                  <button className="btn light" onClick={(e)=>{ e.stopPropagation(); handleDelete(m.id); }}>
                    🗑️ Sil
                  </button>
                </td>
              </tr>
            ))}
            {!scheduledList.length && (
              <tr><td colSpan={9} style={{ color:"#64748b" }}>(Kayıt yok)</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {selectedMail && (
        <div className="card" style={{ background:"#f8fafc" }}>
          <div className="title">📨 Seçilen Mail İçeriği</div>
          <div dangerouslySetInnerHTML={{ __html: selectedMail.contentHtml || "" }} />
        </div>
      )}
    </div>
  );
};

export default MazotMailScheduler;
